export default __webpack_public_path__ + "static/media/Dead (7).15cfabf1.png";